import React, { Component } from 'react';
import ReactEcharts from 'echarts-for-react';

class ProfitChart extends Component {
    getOption = () => {
        const dates = [
            "01-07-2020", "01-09-2020", "01-11-2020", "01-01-2021", "01-03-2021", "01-05-2021", "01-07-2021", 
            "01-09-2021", "01-11-2021", "01-01-2022", "01-03-2022", "01-05-2022", "01-07-2022", "01-09-2022", 
            "01-11-2022", "01-01-2023", "01-03-2023", "01-05-2023", "01-07-2023", "01-09-2023", "01-11-2023", 
            "01-01-2024", "01-03-2024", "01-05-2024", "01-07-2024", "01-09-2024", "01-11-2024", "01-01-2025",  
            "01-03-2025", "01-05-2025", "01-07-2025"
        ];

        const profitData = [
            33495.18, 41841.33, 10753.47, 50436.22, 39686.56, 36192.84, 48000.55, 28018.93, 29108.95, 
            22142.57, 38327.33, -126432.91, 18027.33, 45857.75, 4674.43, 18019.63, -26780.47, -4940.16, 
            54287.65, 78930.69, 49473.11, 46897.81, 47977.41, -45224.03, 65264.67, -13574.67, 73910.13, 
            8057.66, 35941.21, 52823.09, 13539.47, 134153.81, 113587.1, 152853.14, -749.75, -158872.89, 
            22038.48, -26613.07, 69419.17, 171302.06, 45330.98, 111544.41, 119158.69, 170137.22, 58055.23, 
            60671.97, 49047.86, 92890.83, 100455.77
        ];

        return {
            tooltip: { trigger: 'axis' },
            grid: { left: '50px', right: '50px', top: '50px', bottom: '60px' },
            xAxis: {
                type: 'category',
                data: dates,
                axisLabel: { rotate: 45, color: "#74788d" },
                axisLine: { lineStyle: { color: "#74788d" } }
            },
            yAxis: {
                type: 'value',
                axisLine: { lineStyle: { color: "#74788d" } }
            },
            series: [{
                data: profitData,
                type: 'line',
                smooth: true,
                lineStyle: { color: '#008000' }, // Green color for positive values
                itemStyle: {
                    color: (val) => val.value >= 0 ? '#008000' : '#FF0000' // Red for negative values
                }
            }],
        };
    };

    render() {
        return (
            <React.Fragment>
                <ReactEcharts style={{ height: "350px", width: "100%" }} option={this.getOption()} />
            </React.Fragment>
        );
    }
}

export default ProfitChart;
